import React, { Component } from "react";
import {  Row, Col, Button, ListGroup, Form, Alert , Modal } from "react-bootstrap";

//import { LinkContainer } from "react-router-bootstrap";
import "containers/common/List.css";
import ReactTable from "react-table";


import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Creatable from 'react-select/creatable';
import { css } from '@emotion/core';
import { PacmanLoader } from 'react-spinners';

export default class AddressList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "addresses",
            dataRecord: "addresses",
            dataSetPrimaryKey: "street_address_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
        this.setState({ isLoading: true });     
        if (!this.props.isAuthenticated) { // if false
            return;
        }                        

        this.setState({ isLoading: false });      
    }

    



    componentWillUnmount() {
        this.setState({ addresses: [] });
    }



    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }

   

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete address");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleFrontageChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        val = Math.round(parseFloat(val) * 100) / 100; //Round to 2 decimal places
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleStreetInputChange = (cellInfo, event) => {

        let streetOptions = [...this.props.streetOptions];
        streetOptions.push({
            value: event, label: event
        });
        this.props.updateTableState(streetOptions, "streetOptions");

        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event;
        this.props.updateTableState(data, this.state.dataSet);
    }; 

    handleStreetChange = (cellInfo, event) => {
        
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }


    

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            // this.setState({ isLoading: true });
                            const result = await this.handleDataSave(data[i]);
                            // this.setState({ isLoading: false });
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        if (data[cellInfo.index].hasOwnProperty("main_address")) {
            data.sort(function (a, b) { return b.main_address - a.main_address });
        }
        if (data[cellInfo.index].hasOwnProperty("known_as")) {
            data.sort(function (a, b) { return b.known_as - a.known_as });
        }
        this.props.updateTableState(data, this.state.dataSet);

    }

    

    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({
            property_id: this.props.filter.propertyid,
            property_key: null,
            street_name: "",
            main_address: false,
            odd_even: false,
            sort_order: this.props.data.length+1,
            street_num_low: null,
            street_num_low_suffix: null,
            street_num_high: null,
            street_num_high_suffix: null,
            frontage: null,
            known_as: null,
            rp_data_id: null,
            auto_match: false,
            manual_match: false,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            archived_date: null,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }

    
    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        if (cellInfo.column.id == "street_name") {
            if (cellValue) {
                return (<div><Creatable

                    onCreateOption={this.handleStreetInputChange.bind(null, cellInfo)}
                    value={{ value: cellValue, label: this.props.streetOptions.find(o => o.value === cellValue).label }}
                    onChange={this.handleStreetChange.bind(null, cellInfo)}
                    options={this.props.streetOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
            else {
                return (<div><Creatable

                    onCreateOption={this.handleStreetInputChange.bind(null, cellInfo)}
                    onChange={this.handleStreetChange.bind(null, cellInfo)}
                    options={this.props.streetOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
        }
        
        if (["frontage", "street_num_low", "street_num_high", "sort_order"].indexOf(cellInfo.column.id)>0) {
            return (
                <input
                    onChange={this.handleNumberChange.bind(null, cellInfo)}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    type="number"
                    className="no-border form-control"
                    value={cellValue!=null?cellValue:" "}
                    pattern="[0-9]*.[0-9]{2}"
                />
            );
        }
        
        if (["frontage"].indexOf(cellInfo.column.id)>=0) {
            return (
                <input
                    onChange={this.handleFrontageChange.bind(null, cellInfo)}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    type="number"
                    className="no-border form-control"
                    value={cellValue!=null?cellValue:" "}
                    pattern="[0-9]*.[0-9]{2}"
                />
            );
        }

        if (cellInfo.column.id === "known_as") {
            return (
                <input
                    onChange={this.handleInputChange.bind(null, cellInfo)}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    type="text"
                    className="no-border form-control"
                    value={cellValue!=null? cellValue: ""}
                />
            );
        }

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }

    


    renderTable(data) {
        const columns = [

            {
                id: 'street_address_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'street_address_id'
            },
             
            {
                id: 'street_num_low',
                Header: 'St No Low',
                accessor: 'street_num_low',
                maxWidth: 85,
                Cell: this.renderEditable


            },
            {
                id: 'street_num_low_suffix',
                Header: 'St No Low Suffix',
                accessor: 'street_num_low_suffix',
                maxWidth: 85,
                Cell: this.renderEditable

            },
            {
                id: 'street_num_high',
                Header: 'St No High',
                accessor: 'street_num_high',
                maxWidth: 85,
                Cell: this.renderEditable

            },
            {
                id: 'street_num_high_suffix',
                Header: 'St No High Suffix',
                accessor: 'street_num_high_suffix',
                maxWidth: 85,
                Cell: this.renderEditable

            },{
                id: 'known_as',
                Header: 'Known As',
                accessor: 'known_as',
                Cell: this.renderEditable,
                maxWidth: 85

            },
            {
                id: 'street_name',
                Header: 'Street Name',
                accessor: 'street_name',
                Cell: this.renderEditable

            },
            {
                id: 'frontage',
                Header: 'Frontage',
                accessor: 'frontage',
                maxWidth: 85,
                Cell: this.renderEditable

            },
            {
                id: 'sort_order',
                Header: 'Sort Order',
                accessor: 'sort_order',
                maxWidth: 85,
                Cell: this.renderEditable

            }
            ,
            {
                id: 'main_address',
                Header: 'Main Address',
                accessor: 'main_address',
                maxWidth: 85,
                Cell: this.renderEditable

            }, {
                id: 'last_edited_date',
                Header: 'Last Edited',
                maxWidth: 85,
                accessor: d => {
                    if (d.start_date) {
                        return Moment(d.last_edited_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                }

            },
            {
                id: 'last_edited_by',
                Header: 'Edited By',
                accessor: 'last_edited_by',
                maxWidth: 85

            },{
                Header: '',
                accessor: 'street_address_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }

    }

    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0
                        ?
                        <ListGroup.Item key={i} as="a" header={d.street_address}>
                            { (d.sort_order.toString() + ") ") 
                            + (d.street_num_low || "") 
                            + (d.street_num_low_suffix || "") 
                            + (d.street_num_high !== d.street_num_low && d.street_num_high ? (" - " +(d.street_num_high || "") + (d.street_num_high_suffix || "")) : "")  
                            + ((d.known_as || "").length > 0 ?" ("+ d.known_as+")" :"" )
                            + " " + d.street_name 
                            + (d.main_address ? " (main address)" : "") }
                        </ListGroup.Item>
                        : ""
            );
        }
    }

 

    renderComponent() {
        return (
            <div className="addresses">
                <Modal show={this.state.showAlert && this.props.data[this.props.data.length-1].street_address_id} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showAlert && !this.props.data[this.props.data.length-1].street_address_id &&
                                    <Alert variant="danger">{this.state.errorMessage}</Alert>
                                    }
                {this.props.controlType === "table" && <Row className="show-Container">
                    <Col className="text-right" >
                        
                        <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>

                    </Col>
                </Row>}

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {this.state.isLoading &&
                            <div className="outer-div">
                                <div className='sweet-loading inner-div' >
                                    <PacmanLoader
                                        css={css`
                                        display: block;
                                        margin: 0 auto;
                                        border-color: red`}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#e03c31'}
                                        loading={this.state.isLoading}
                                    />
                                </div>
                            </div>
                        }
                        { !this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : this.renderList(this.props.data) }
                        </Col>
                    </Row>
               

            </div>
        );
    }
    render() {
        if (!this.props.data) {
            return null
        }
        else {
            return (

                <div className="AddressSection">
                    {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
                </div>
            );
        }
  }
}
